import React from 'react'

export const WrapperIntegrationSkeleton = () => (
  <div className="bg-skeleton-primary h-[200px] w-full rounded-md md:h-[220px] md:w-[320px]" />
)
